import { useMemo } from 'react';
import type { ProfileMenuItem } from '@packages/ui/layout';
import AuthService from '@/services/authService';

interface UseProfileMenuOptions {
  canSwitch: boolean;
  onSwitchInstance: () => void;
}

/**
 * Builds customer-specific profile dropdown menu items.
 */
export function useProfileMenu({
  canSwitch,
  onSwitchInstance,
}: UseProfileMenuOptions): ProfileMenuItem[] {
  const hash = window.location.hash;

  return useMemo(() => {
    const authService = new AuthService();

    const items: ProfileMenuItem[] = [
      {
        id: 'profile',
        label: 'My Profile',
        path: `/profile${hash}`,
        visible: true,
      },
      {
        id: 'switch-instance',
        label: 'Switch Instance',
        onClick: onSwitchInstance,
        visible: canSwitch,
      },
      {
        id: 'notification',
        label: 'Notification',
        path: `/notification${hash}`,
        visible: true,
        permission: { type: 'View', urlName: 'notification' },
      },
      {
        id: 'security',
        label: 'Security',
        path: `/security${hash}`,
        visible: true,
      },
      {
        id: 'logout',
        label: 'Logout',
        onClick: () => {
          localStorage.removeItem('reportType');
          void authService.logout();
        },
        visible: true,
        variant: 'danger',
      },
    ];

    return items;
  }, [hash, canSwitch, onSwitchInstance]);
}
